import { NSARouterMakerResult } from 'namirasoft-account-react';
import { UserFullRow } from 'namirasoft-password';
import { Component } from 'react';
import ImportColumnSettingsStep from '../components/ImportColumnSettingsStep';
import ImportFileStep from '../components/ImportFileStep';
import ImportPasswordStep from '../components/ImportPasswordStep';
import { PasswordLayout } from '../PasswordLayout';
import { PasswordRouterProps } from '../PasswordRouterProps';

export interface ImportedRow
{
    id: number;
    name: string;
    username: string;
    password: string;
    url: string;
    hash: string;
    description?: string;
    category_name?: string;
    category_id?: string;
    imported: boolean;
}

export interface ImportPageProps extends NSARouterMakerResult, PasswordRouterProps
{
    user: UserFullRow;
}

export interface ImportPageState
{
    step: number;
    csv_headers: string[];
    csv_body: string[][];
    imported_rows: ImportedRow[];
}

class ImportPage extends Component<ImportPageProps, ImportPageState>
{
    constructor(props: ImportPageProps)
    {
        super(props);
        this.state = { step: 1, csv_headers: [], csv_body: [], imported_rows: [] };
    }

    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                action={{
                    title: 'Import',
                    description: "Bring existing passwords into your vault from a CSV file, mapping its columns to Namirasoft Password fields."
                }}
            >
                <>
                    <div style={{ display: this.state.step === 1 ? undefined : 'none' }}>
                        <ImportFileStep
                            {...this.props}
                            onComplete={(csv_headers, csv_body) => this.setState({ csv_headers, csv_body, step: 2 })}
                        />
                    </div>
                    <div style={{ display: this.state.step === 2 ? undefined : 'none' }}>
                        <ImportColumnSettingsStep
                            {...this.props}
                            csvHeaders={this.state.csv_headers}
                            csvBody={this.state.csv_body}
                            onComplete={(imported_rows) => this.setState({ imported_rows, step: 3 })}
                            onBack={() => this.setState({ step: 1 })}
                        />
                    </div>
                    <div style={{ display: this.state.step === 3 ? undefined : 'none' }}>
                        <ImportPasswordStep
                            {...this.props}
                            importedRows={this.state.imported_rows}
                            onBack={() => this.setState({ step: 2 })}
                        />
                    </div>
                </>
            </PasswordLayout>
        );
    }
}

export default ImportPage;